import MojitoCore from 'mojito/core';
import SingleLeagueCoupon from './single-league-coupon.js';

const { UIView } = MojitoCore.Presentation;

/**
 * A module view that presents content for a sport match specific to a location.
 *
 * @class SingleLeagueCoupon
 * @memberof Mojito.Modules.SingleLeagueCoupon
 */

export default UIView('SingleLeagueCoupon', SingleLeagueCoupon);
